"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importStar(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const TypeCounter = (0, react_1.forwardRef)((props, ref) => {
    const { icon, value, isActive, hasFilter, enableActivity, onClick, type, hideOnZero } = props, remainingProps = tslib_1.__rest(props, ["icon", "value", "isActive", "hasFilter", "enableActivity", "onClick", "type", "hideOnZero"]);
    const wrapperClassName = (0, classnames_1.default)('TypeCounter', 'display-flex align-items-center', 'user-select-none', enableActivity ? 'cursor-pointer' : 'pointer-events-none', enableActivity && hasFilter && !isActive && 'opacity-50');
    const counterClassNames = (0, classnames_1.default)('TreeLabelCount', 'label label-condensed', isActive ? 'label-primary' : 'label-muted label-filled');
    const handleClick = () => onClick(type);
    if (hideOnZero && !value) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: ref }, remainingProps, { className: wrapperClassName, onClick: handleClick }, { children: [(0, jsx_runtime_1.jsx)("span", { className: `rioglyph rioglyph-${icon} text-size-16 margin-right-2 margin-left--4` }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: counterClassNames }, { children: value || 0 }))] })));
});
TypeCounter.defaultProps = {
    hideOnZero: false,
};
TypeCounter.propTypes = {
    type: prop_types_1.default.string,
    icon: prop_types_1.default.string,
    // Highlights the current active filter
    isActive: prop_types_1.default.bool,
    // Defined if there is a filter
    hasFilter: prop_types_1.default.bool,
    // Allow the counter to be clickable
    enableActivity: prop_types_1.default.bool,
    hideOnZero: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node, prop_types_1.default.number]),
};
exports.default = TypeCounter;
